export enum AppRoutes {
  Login = "login",
  Root = "",
  Dashboard = "dashboard",
  LoginCallback = "login/callback",
  InternalUserRegistration = "registration",
  AdminDashboard = "admin-dashboard",
  Help = "help",
  EditApp = "edit-app",
  NotificationList = "notification-list",
  PageNotFound = "page-not-found",
}
export const AppRoutePaths = {
  [AppRoutes.Login]: `/${AppRoutes.Login}`,
  [AppRoutes.Root]: `/${AppRoutes.Root}`,
  [AppRoutes.Dashboard]: `/${AppRoutes.Dashboard}`,
  [AppRoutes.LoginCallback]: `/${AppRoutes.LoginCallback}`,
  [AppRoutes.InternalUserRegistration]: `/${AppRoutes.InternalUserRegistration}`,
  [AppRoutes.Help]: `/${AppRoutes.Help}`,
  [AppRoutes.AdminDashboard]: `/${AppRoutes.Dashboard}/${AppRoutes.AdminDashboard}`,
  [AppRoutes.EditApp]: `/${AppRoutes.Dashboard}/${AppRoutes.EditApp}`,
  [AppRoutes.NotificationList]: `/${AppRoutes.Dashboard}/${AppRoutes.NotificationList}`,
};
